/**
 * Route for `liftoff-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LiftoffIntegrationPage } from "../features/liftoff-integration/LiftoffIntegrationPage";

export const liftoffIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/liftoff-integration",
	component: LiftoffIntegrationPage,
});

export default liftoffIntegrationRoute;
